import React from "react";
import PropTypes from "prop-types";
import { Delete, Input, Field, Control, Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TextareaAutosize from "react-textarea-autosize";

function InspectionItem({
  item,
  disabled = false,
  removeRow,
  handleChange,
  insertAfter
}) {
  const defaultDisabled = true;
  return (
    <Field kind="group">
      <Control>
        <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
          <Delete
            disabled={disabled}
            style={{ opacity: disabled ? 0 : 1 }}
            onClick={removeRow}
          />
        </div>
      </Control>
      <Control style={{ width: 55 }}>
        <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
          <Input
            name={`LineItem_${item.RecId}`}
            readOnly={defaultDisabled}
            style={{ textAlign: "center" }}
            type="number"
            value={item.LineItem ? parseFloat(item.LineItem) : 0}
            onChange={handleChange}
          />
        </div>
      </Control>
      <Control expanded>
        <TextareaAutosize
          required
          className="auto-height-textarea input"
          disabled={disabled}
          minRows={1}
          name={`Description_${item.RecId}`}
          type="text"
          value={item.Description}
          onChange={handleChange}
        />
      </Control>
      <Control>
        <Button
          color="link"
          disabled={disabled}
          style={{ opacity: disabled ? 0 : 1 }}
          type="button"
          onClick={insertAfter}
        >
          <Icon>
            <FontAwesomeIcon icon="plus" />
          </Icon>
        </Button>
      </Control>
    </Field>
  );
}

InspectionItem.propTypes = {
  item: PropTypes.object,
  disabled: PropTypes.bool,
  removeRow: PropTypes.func,
  handleChange: PropTypes.func,
  insertAfter: PropTypes.func
};
export default InspectionItem;
